import React, { useState, useEffect, useContext } from 'react';
import { DeveloperDataContext } from '../../../../lems-ui/src/pages/app';
import { getAllBanks } from '../../common/constants/api';
import BankDetails from './BankDetails';
import styles from './Card.module.css';

const AllBanks = props => {
  let { companyId } = props;
  const { cardsContainer } = styles;
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState({ id: 1, name: 'HDFC' });

  const context = useContext(DeveloperDataContext);

  useEffect(() => {
    getAllBanks().then(res => {
      setBanks(
        res.map(each => ({ id: each?.id, key: each?.name, name: each?.name }))
      );
    });
  }, []);

  useEffect(() => {}, [context.appData.bankReload]);

  return (
    <div className="w-full">
      <div className={`${cardsContainer} w-full flex space-x-3 mt-8`}>
        {banks.map((each, i) => (
          <div
            className={`${
              selectedBank.name == each.key
                ? 'bg-green-tePapaGreen text-white'
                : ' bg-white text-black-500'
            } text-roboto flex items-center justify-center`}
            style={{ minWidth: '120px' }}
            key={`bank${i}`}
          >
            <button
              className="w-full h-full cursor-pointertext-xs"
              onClick={() => {
                setSelectedBank({ id: each?.id, name: each?.name });
              }}
            >
              {each.name}
            </button>
          </div>
        ))}
      </div>
      {selectedBank.name !== '' && (
        <BankDetails companyId={companyId} bankId={selectedBank.id} />
      )}
    </div>
  );
};

export default AllBanks;
